import React, {useCallback, useEffect, useState} from 'react';
import {
  ActivityIndicator,
  ScrollView,
  View,
  Platform,
  Modal,
  TouchableOpacity,
  StyleSheet,
  Dimensions,
  Alert,
} from 'react-native';

import {
  useFocusEffect,
  useNavigation,
  useRoute,
} from '@react-navigation/native';
import * as Progress from 'react-native-progress';
import {Text} from 'react-native';
import ButtonComponent from '../../components/ButtonComponent/ButtonComponent';
import SearchHeader from '../../components/SearchHeader/SearchHeader';
import SalesService from '../../services/SalesService/SalesService';
import {ProductInCart, useBagStore} from '../../store/BagStore';
import {useLimitStore} from '../../store/LimitStore';
import BagList from './components/BagList/BagList';
import MinimumAlert from './components/MinimumAlert/MinimumAlert';
import NoInfoAlert from './components/NoInfoAlert/NoInfoAlert';
import NotBag from './components/NotBag/NotBag';
import VesselAlert from './components/VesselAlert/VesselAlert';
import {styles} from './styles';
import {useAuthStore} from '../../store/AuthStore';
import {useUserStore} from '../../store/UserStore';
import {NavigationProps} from '../../navigation/Routes';
import {AppRoutes} from '../../navigation/Routes.types';
import {clientLimitsGet} from '../../services/ProductsService/ProductsService';
import ProductsService from '../../services/ProductsService/ProductsService';
import {Colors} from '../../constants/Colors';
import useSuggestedComboStore from '../../store/useSuggestedComboStore';
import AxiosService from '../../services/AxiosService';
import useExtendedTermsStore from '../../store/ExtendedTermsStore';
import PendingDebtAlert from './components/PendingDebtAlert/PendingDebtAlert';
import OrdersService from '../../services/OrdersService/OrdersService';
import {useLoadingStore} from '../../store/LoadingStore';
import DebtsService from '../../services/DebtsService/DebtsService';
import UnavailableModal, {
  UnavailableProduct,
} from './components/UnavailableModal/UnavailableModal';
import FeaturedProductsCarousel from '../../components/FeaturedProductsCarousel/FeaturedProductsCarousel';
import { useIsDesktop } from '../../hooks/useIsDesktop';
import TemporaryPasswordBanner from '../../components/TemporaryPasswordBanner/TemporaryPasswordBanner';
import { showInfo } from '../../utils/globalAlert';
import {useSuggestedOrderFill} from './hooks/useSuggestedOrderFill';

export interface PostProductBody {
  sku: string;
  total: number;
  usePrice: number;
  faixaVolume5: string;
  faixaVolume4: string;
  faixaVolume3: string;
  faixaVolume2: string;
  KVGR1: string;
}

const Bag = () => {
  const isDesktop = useIsDesktop();
  const [itensBag, setItensBag] = useState([]);
  const [hasContainer, setHasContainer] = useState<boolean>(false);
  const [totalContainer, setTotalContainer] = useState<
    {description: string; total: number; vessel: string}[]
  >([]);
  const [forceRender, setForceRender] = useState<boolean>(false);
  const {goBack, navigate, setParams} = useNavigation<NavigationProps>();
  const {} = useAuthStore();
  const products = useBagStore(state => state.products);
  const totalPrice = useBagStore(state => state.getTotalPrice());
  const totalItems = useBagStore(state => state.getTotalItems());
  const {clearCart, addProduct, removeProduct, updateProductQuantity} =
    useBagStore();
  const temporaryPasswordLogin = useUserStore(state => state.temporaryPasswordLogin);

  const route = useRoute();

  const handleAddBag = (product: any, quantity: number) => {
    const existingProduct = products.find(
      (prod: any) => prod.sku === product.sku,
    );
    if (existingProduct) {
      const updatedProducts = products.map((prod: any) =>
        prod.sku === product.sku ? {...prod, quantity} : prod,
      );
      // Atualizar produto no store
      addProduct({...product, quantity});
    } else if (quantity > 0) {
      addProduct({
        ...product,
        quantity: quantity,
      });
    }
  };

  const openProduct = (product: any) => {
    navigate(AppRoutes.PRODUCT_DETAILS, {item: product});
  };
  const {user} = useUserStore();
  const [vesselCheck, setVesselCheck] = useState<boolean>(false);

  const {limit, minOrder, setLimit, setMinOrder, setBalance} = useLimitStore();

  // Inicia como true: o botao Continuar deve nascer travado e so liberar
  // depois que getLimits (chamado no mount) terminar de carregar o limite.
  const [loadingLimit, setLoadingLimit] = useState<boolean>(true);
  const [repeatOrder, setRedoLastOrder] = useState<boolean>(false);
  const [loadingProducts, setLoadingProducts] = useState<boolean>(false);

  const [attachCheck, setAttachCheck] = useState<boolean>(false);
  const [minimumOrder, setMinimumOrder] = useState<number | null>(300);
  const [limitCredito, setLimitCredito] = useState<number | null>(0);
  const [unavailableProducts, setUnavailableProducts] = useState<
    UnavailableProduct[]
  >([]);

  const [showPendingDebtAlert, setShowPendingDebtAlert] = useState<boolean>(false);

  const [showUnavailableModal, setShowUnavailableModal] =
    useState<boolean>(false);
  const {showLoading, hideLoading} = useLoadingStore();
  const INVOICE_FEE = 5;
  const [openRecomendations, setOpenRecomendations] = useState<boolean>(false);

  const getLimits = async () => {
    setLoadingLimit(true);

    setMinimumOrder(null);
    setLimitCredito(null);

    try {
      if (!limit) {
        const response = await clientLimitsGet(user?.clientCode);
        setMinimumOrder(response.Minimoorder ?? null);
        setLimitCredito(response.Limitecredito ?? null);
        setLimit(response.Limitecredito ?? null);
        setMinOrder(response.Minimoorder ?? null);
        setBalance(response.Saldodisponivel ?? null);
      } else {
        setMinimumOrder(minOrder ?? null);
        setLimitCredito(limit ?? null);
      }
    } catch (error) {
      console.error('Erro ao carregar limite do cliente:', error);
      // Mantem minimumOrder/limitCredito nulos: NoInfoAlert aparece e o botao
      // segue travado ate o usuario tentar recarregar.
      setMinimumOrder(null);
      setLimitCredito(null);
    } finally {
      setLoadingLimit(false);
    }
  };
  const {
    setCombos,
    setLoading,
    loading: loadingCombos,
    clearAll,
    setCompletedCombos,
    setToCompleteCombos,
    setOriginalCombos,
    completedCombos,
    toCompleteCombos,
  } = useSuggestedComboStore();

  useEffect(() => {
    if (user?.clientCode) {
      // Verifica e agenda pedidos apenas uma vez
      checkDebtAlert(user?.clientCode);
    }
  }, [user?.clientCode]);

  const checkDebtAlert = async () => {
    try {
      const response = await DebtsService.GetUpdatedDebts(user?.clientCode);

      const date = new Date();
      const showAlert = response.some(debt => {
        if (debt.status === 'succeeded') return false;
        const expire = new Date(debt.ZFBDT);
        const diffTime = date.getTime() - expire.getTime();
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

        return diffDays > 15;
      });

      if (showAlert) {
        setShowPendingDebtAlert(true);
      }
    } catch (error) {
      console.error('Erro ao verificar débitos:', error);
      setShowPendingDebtAlert(false);
    }
  };

  useEffect(() => {
    getLimits();
    sendCart(products);
  }, []);

  /**
   * `origin` só é enviado pelo preenchimento automático do pedido sugerido.
   * Sem o campo o backend grava `client`, então qualquer edição manual da
   * sacola devolve o carrinho ao cliente e ele volta a ser alvo da campanha de
   * carrinho abandonado.
   */
  const sendCart = async (products: any[], origin?: string) => {
    const instance = AxiosService.createProductsAxiosInstance();
    const data = products.map(product => ({
      sku: product.sku,
      quantity: product.quantity,
    }));
    const response = await instance.post(
      '/carts',
      {
        client_code: user?.clientCode,
        data,
        ...(origin ? {origin} : {}),
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
  };
  // CA-03: chegou pela modal ou pela notificação de pedido sugerido.
  const {loadingSuggestedOrder} = useSuggestedOrderFill({
    enabled: Boolean((route?.params as any)?.suggestedOrder),
    clientCode: user?.clientCode,
    sendCart,
    onFinish: useCallback(
      () => setParams({suggestedOrder: undefined} as never),
      [setParams],
    ),
    onEmpty: useCallback(
      () =>
        Alert.alert(
          'Nenhum produto sugerido disponível',
          'Não encontramos produtos do seu pedido sugerido disponíveis hoje. Monte seu carrinho pelo catálogo!',
          [
            {text: 'Ir para o catálogo', onPress: () => navigate(AppRoutes.MAIN_TAB_SCREEN as never)},
            {text: 'Fechar', style: 'cancel'},
          ],
        ),
      [navigate],
    ),
  });

  // PED-13 RN-16 — o pedido programado NÃO passa mais por aqui. Ele era
  // despejado nesta sacola (editável) por `useScheduledProposalFill`, e o
  // refino fechou isso: "sem alteração de quantidade, sem inclusão e sem
  // remoção pelo cliente. A escolha do cliente é binária". A revisão acontece
  // em `ScheduledOrderReview`, que só monta a sacola no instante em que o
  // cliente confirma e segue direto ao checkout — sem tela editável no meio.

  const createObjectList = number => {
    return Array.from({length: number}, (v, i) => ({
      id: i + 1,
      name: `Item ${i + 1}`,
    }));
  };

  const subscribe = useBagStore.subscribe;

  useEffect(() => {
    const unsubscribe = subscribe(
      state => state.products,
      products => {},
    );

    return () => unsubscribe();
  }, [subscribe]);

  const calcularTotalVasilhames = produtos => {
    const containers: {description: string; total: number; vessel: string}[] =
      [];

    produtos.forEach(produto => {
      if (produto.vasilhame !== '') {
        const mult = produto?.vasilhame * produto?.quantity;
        const description = produto.descricao
          .replace(/Retornável/gi, '')
          .replace(' - ', '')
          .trim();
        const complement = produto.complemento
          .replace('- R$', '')
          .replace(/\(CX\/[^ ]*/, '')
          .trim();
        containers.push({
          description: description + ' ' + complement + ' ',
          total: mult,
          vessel: 'recipientes',
        });
      }
    });
    setTotalContainer(containers);
  };

  const forceRenderFunc = () => {
    setForceRender(true);

    setTimeout(() => {
      setForceRender(false);
    }, 1000);
  };
  const {
    data: extendedTerms,
    loading: extendedTermsLoading,
    error: extendedTermsError,
  } = useExtendedTermsStore();
  const [percentage, setPercentage] = React.useState(0);
  const [remaining, setRemaining] = React.useState(0);
  const [days, setDays] = React.useState(0);
  useEffect(() => {
    if (totalPrice > 0) {
      const quota = extendedTerms?.value || 0;
      setPercentage(Math.min((totalPrice / quota) * 100, 100));
      setRemaining(Math.max(quota - totalPrice, 0));
      setDays(extendedTerms?.days || 0);
    }
  }, [totalPrice]);

  const handleContinue = async (fromModal = false) => {
    if (products.length > 0) {
      const hasUnavailableItems = await verifyDisponibility();

      if (hasUnavailableItems) {
        setShowUnavailableModal(true);
      } else {
        navigate(AppRoutes.CHECKOUT);
      }
    } else {
      // Navigate to the main tab navigator and open the Home tab (Home is inside MainTabScreen)
      (navigate as any)(AppRoutes.MAIN_TAB_SCREEN, {screen: 'Home'});
    }
  };

  const getProductsForPost = () => {
    const productsInCart = useBagStore.getState().products;
    const productsForPost = productsInCart.map(product => ({
      sku: product.sku,
      total: product.quantity,
      usePrice: product.discountedPrice
        ? product.discountedPrice
        : product.preco,
      faixaVolume5: '0',
      faixaVolume4: '0',
      faixaVolume3: '0',
      faixaVolume2: '0',
      KVGR1: product?.KVGR1 || product?.kvgr1,
    }));
    return productsForPost;
  };

  const verifyDisponibility = async () => {
    const clientCode: string =
      (user?.current_client?.clientCode ?? user?.clientCode) || '';
    const productsForPost = getProductsForPost();
    try {
      showLoading();
      const result = await SalesService.VerifyDisponibility(
        clientCode,
        productsForPost,
      );

      if (result.hasUnavailableProducts) {
        const unavailableProductsList = result.unavailableProducts;
        setUnavailableProducts(unavailableProductsList);
        return true;
      }
      setUnavailableProducts([]);
      return false;
    } catch (error) {
      if (error && typeof error === 'object' && 'response' in error) {
        console.error(
          'Error verifying availability:',
          error.response?.data || error,
        );
      } else {
        console.error('Error verifying availability:', error);
      }
      return false;
    } finally {
      hideLoading();
    }
  };

  /**
   * Atualiza o carrinho baseado nos produtos indisponíveis
   * - price_mismatch: Atualiza o preço do produto usando dados da API
   * - insufficient_stock: Ajusta quantidade ou remove se qty = 0
   * - not_found / catalog_not_found: Remove o produto
   */
  const handleUpdateCart = () => {
    const currentProducts = useBagStore.getState().products;

    unavailableProducts.forEach(unavailableItem => {
      const skuNormalized = unavailableItem.sku.replace(/^0+/, '');
      const cartProduct = currentProducts.find(
        p => p.sku.replace(/^0+/, '') === skuNormalized,
      );

      if (!cartProduct) return;

      const cartProductKey = (cartProduct as any).cartKey ?? cartProduct.sku;

      switch (unavailableItem.reason) {
        case 'price_mismatch':
          if (unavailableItem.correctPrice !== undefined) {
            const currentQuantity = cartProduct.quantity;
            removeProduct(cartProductKey);

            if (unavailableItem.product) {
              const apiProduct = unavailableItem.product;
              const updatedProduct = {
                ...cartProduct,
                preco: apiProduct.PRECO,
                faixaVolume2: apiProduct.FAIXA2VOLUME,
                faixaVolume3: apiProduct.FAIXA3VOLUME,
                faixaVolume4: apiProduct.FAIXA4VOLUME,
                faixaVolume5: apiProduct.FAIXA5VOLUME,
                kdkg2: apiProduct.KDKG2,
                kdkg3: apiProduct.KDKG3,
                kdkg4: apiProduct.KDKG4,
                kdkg5: apiProduct.KDKG5,
                quantity: currentQuantity,
              };
              addProduct(updatedProduct);
            } else {
              addProduct({
                ...cartProduct,
                preco: unavailableItem.correctPrice,
                quantity: currentQuantity,
              });
            }
          }
          break;

        case 'insufficient_stock':
          if (
            unavailableItem.availableQty &&
            unavailableItem.availableQty > 0
          ) {
            updateProductQuantity(
              cartProductKey,
              unavailableItem.availableQty,
            );
          } else {
            removeProduct(cartProductKey);
          }
          break;

        case 'combo_limit_exceeded':
          if (
            unavailableItem.availableQty &&
            unavailableItem.availableQty > 0
          ) {
            updateProductQuantity(
              cartProductKey,
              unavailableItem.availableQty,
            );
          } else {
            removeProduct(cartProductKey);
          }
          break;

        case 'not_found':
        case 'catalog_not_found':
        case 'combo_error':
        case 'combo_processing_error':
          removeProduct(cartProductKey);
          break;
      }
    });

    setUnavailableProducts([]);
    setShowUnavailableModal(false);
    forceRenderFunc();
  };

  /**
   * Limpa todo o carrinho a partir do modal
   */
  const handleClearCartFromModal = () => {
    clearCart();
    setUnavailableProducts([]);
    setShowUnavailableModal(false);
  };

  const processBagItem = (item: any, index: number) => {
    const isUnavailable = unavailableProducts.find(
      unavailableItem => item.sku.replace(/^0+/, '') == unavailableItem.sku,
    );
    return (
      <BagList
        key={(item as any).cartKey ?? item.sku}
        item={item}
        index={index}
        forceRender={forceRenderFunc}
        markAsUnavailable={isUnavailable !== undefined}
        isUnavailable={isUnavailable}
        setOpenRecomendations={value => setOpenRecomendations(value)}
      />
    );
  };

  const hasItemWithContainer = () => {
    return products.some(item => item.vasilhame !== '');
  };

  useEffect(() => {
    const objectList = createObjectList(products);
    setItensBag(objectList);
  }, [products]);

  useEffect(() => {
    if (route?.params?.repeatOrder) {
      setRedoLastOrder(route?.params?.repeatOrder);
      setLoadingProducts(true);

      // Refazer pedido SUBSTITUI a sacola: sem isto o último pedido era somado
      // ao que já estava lá.
      clearCart();

      const fetchData = async () => {
        try {
          const response = await OrdersService.MyOrdersPost(30, '', '', '', '');

          if (response?.statusPedidos?.length) {
            const pedidoMaisRecente = response.statusPedidos.reduce(
              (maisRecente, pedidoAtual) => {
                const dataAtual = new Date(pedidoAtual.ERDAT);
                const dataMaisRecente = new Date(maisRecente.ERDAT);

                return dataAtual > dataMaisRecente ? pedidoAtual : maisRecente;
              },
            );

            let skus = '';
            let perPage = 1;
            let itens = pedidoMaisRecente?.Itens?.Item;

            if (Array.isArray(itens)) {
              perPage = itens.length;
              skus = itens
                .map(product => product.MATNR)
                .filter(Boolean)
                .join(',');
            } else {
              itens = [itens];
              if (itens[0]?.MATNR) {
                skus = itens[0].MATNR;
              }
            }

            const response2 = await ProductsService.catalogProductsGet(
              user?.clientCode,
              perPage,
              1,
              undefined,
              undefined,
              undefined,
              undefined,
              skus,
            );

            // Limpa de novo: o cliente pode ter mexido na sacola durante a
            // busca do último pedido no SAP.
            clearCart();
            response2?.data?.products?.forEach(product => {
              const originalItem = itens.find(
                item => item.MATNR == product.sku,
              );
              const quantity = originalItem?.KWMENG ?? 0;

              addProduct({
                ...product,
                quantity: parseInt(quantity),
              });
            });
          } else {
            showInfo(
              'Nenhum pedido recente encontrado',
              'Monte seu carrinho novamente no catálogo!',
            );
          }
        } catch (error) {
          Alert.alert('Erro ao buscar carrinho: tente novamente mais tarde.');
          console.error('Erro ao buscar carrinho:', error);
        } finally {
          setLoadingProducts(false);
        }
      };

      fetchData();
    }
  }, [route?.params?.repeatOrder]);

  useEffect(() => {
    const hasItem = products.some(item => item.vasilhame);
    setHasContainer(hasItem);
    calcularTotalVasilhames(products);
  }, [products]);

  useFocusEffect(
    useCallback(() => {
      forceRenderFunc();
    }, []),
  );
  if (loadingCombos) {
    return (
      <View style={styles.loadingContainer}>
        <ActivityIndicator size="large" color="#E91E63" />
      </View>
    );
  }
  return (
    <>
      <ScrollView
        style={[styles.scrollView, isDesktop && { maxWidth: 800, alignSelf: 'center', width: '100%' }]}
        contentContainerStyle={{paddingBottom: 280}}>
        <SearchHeader
          onPress={() =>
            (navigate as any)(AppRoutes.MAIN_TAB_SCREEN, {screen: 'Home'})
          }
          title="Sacola"
        />
        <TemporaryPasswordBanner />
        {showPendingDebtAlert && <PendingDebtAlert />}
        {!loadingLimit && (minimumOrder === null || limitCredito === null) && (
          <NoInfoAlert getLimits={getLimits} loadingLimit={loadingLimit} />
        )}
        {minimumOrder !== null &&
          totalPrice < minimumOrder &&
          totalPrice > 0 && <MinimumAlert minimumOrder={minimumOrder} />}
        <View style={styles.containerAlert}>
          {hasContainer && (
            <VesselAlert
              containers={totalContainer}
              returnCheck={val => {
                setVesselCheck(val);
              }}
              redirectContainers={() =>
                hasItemWithContainer()
                  ? () => navigate(AppRoutes.CONTAINERS)
                  : null
              }
            />
          )}
        </View>

        {forceRender || loadingSuggestedOrder || (repeatOrder && loadingProducts) ? (
          <ActivityIndicator
            color={Colors.RedPallete.red}
            size={20}
            style={{alignSelf: 'center'}}
          />
        ) : (
          <View style={styles.containerList}>
            {products.length > 0 ? (
              products.map((item: ProductInCart, index: number) =>
                processBagItem(item, index),
              )
            ) : (
              <NotBag
                description="Você não tem produtos na
      sacola. Aproveite e escolha seus produtos Brasal Refrigerantes!"
                title="Ops.. Está vazia!"
              />
            )}
          </View>
        )}

        {/* Carrossel de Produtos Imperdíveis */}
        {products.length > 0 && (
          <FeaturedProductsCarousel
            handleAddBag={handleAddBag}
            openProduct={openProduct}
          />
        )}

        {/* <View style={styles.sugestedContainer}>
          <SugestedProducts handleAddBag={handleAddBag} />
        </View> */}
      </ScrollView>

      <View
        style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          backgroundColor: '#fff',
          paddingHorizontal: 16,
          paddingVertical: 16,
          borderTopWidth: 1,
          borderTopColor: '#ddd',
          ...(isDesktop ? {
            left: '50%',
            right: 'auto',
            transform: [{ translateX: '-50%' }],
            width: '100%',
            maxWidth: 800,
            borderRadius: 12,
            borderWidth: 1,
            borderColor: '#e0e0e0',
            bottom: 12,
          } : {}),
          height:
            !extendedTermsLoading &&
            !extendedTermsError &&
            extendedTerms &&
            (percentage > 0 || remaining > 0)
              ? 250
              : 150,
        }}>
        {forceRender ? (
          <></>
        ) : (
          products.length > 0 && (
            <>
              {!extendedTermsLoading &&
                !extendedTermsError &&
                extendedTerms && (
                  <View
                    style={[
                      styles.extendedTermsCard,
                      {
                        flexDirection:
                          remaining > 0 && percentage > 0
                            ? 'column'
                            : 'row-reverse',
                        ...(remaining <= 0 || percentage <= 0
                          ? {
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: 10,
                            }
                          : {}),
                      },
                    ]}>
                    {remaining > 0 ? (
                      <Text style={styles.extendedTermsCardText}>
                        Faltam{' '}
                        <Text style={styles.highlightedText}>
                          {remaining.toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                          })}
                        </Text>{' '}
                        para ter{' '}
                        <Text style={styles.highlightedText}>
                          {extendedTerms.days} dias para pagar!
                        </Text>
                      </Text>
                    ) : (
                      remaining === 0 && (
                        <Text style={styles.extendedTermsCardText}>
                          Seu boleto será gerado com{' '}
                          <Text style={styles.highlightedText}>
                            {extendedTerms.days} dias para pagar!
                          </Text>
                        </Text>
                      )
                    )}
                    {percentage > 0 && (
                      <View style={styles.progressContainer}>
                        {remaining > 0 && (
                          <Progress.Bar
                            progress={percentage / 100}
                            width={null}
                            height={10}
                            color={Colors.RedPallete.red}
                            borderRadius={5}
                            style={{marginBottom: 10, flex: 1}}
                            unfilledColor={'#fff'}
                            borderWidth={0}
                          />
                        )}
                        {percentage >= 100 && (
                          <View style={styles.checkIcon}>
                            <Text style={styles.checkIconText}>✓</Text>
                          </View>
                        )}
                      </View>
                    )}
                  </View>
                )}
              <View style={styles.spaceSummary}>
                <View style={styles.containerSummary}>
                  <Text style={styles.summaryText}>Resumo</Text>
                  <Text style={styles.quantityText}>{totalItems} itens</Text>
                </View>
                <View style={styles.containerSubtotal}>
                  <Text style={styles.subtotalText}>Subtotal</Text>
                  <Text style={styles.priceText}>
                    {totalPrice.toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
                  </Text>
                </View>
              </View>
            </>
          )
        )}
        {forceRender ? (
          <></>
        ) : (
          <>
            <View style={[styles.containerButton, isDesktop && { maxWidth: 400, alignSelf: 'center' }]}>
              <ButtonComponent
                disabled={
                  // Enquanto o limite/minimo nao carregou, mantem o botao
                  // travado. Sem isso, durante o load minimumOrder fica null e
                  // `totalPrice >= null` (=> >= 0) libera o botao, permitindo
                  // que um clique rapido burle a trava antes do limite chegar.
                  ((loadingLimit || minimumOrder === null) &&
                    products.length > 0) ||
                  (!(
                    totalPrice >= minimumOrder ||
                    (totalPrice < minimumOrder && attachCheck)
                  ) &&
                    products.length > 0) ||
                  (hasItemWithContainer() && !vesselCheck) ||
                  showPendingDebtAlert ||
                  temporaryPasswordLogin
                }
                title={
                  products.length > 0 ? 'Continuar' : 'Quero adicionar produtos'
                }
                width="100%"
                onPress={handleContinue}
              />
            </View>
          </>
        )}
      </View>
      <UnavailableModal
        visible={showUnavailableModal}
        unavailableProducts={unavailableProducts}
        cartProducts={products}
        onUpdateCart={handleUpdateCart}
        onClearCart={handleClearCartFromModal}
        onClose={() => setShowUnavailableModal(false)}
      />
    </>
  );
};

export default Bag;
